import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/tit_bj.png';
import _imports_1 from '@/assets/user/user.png';
import _imports_2 from '@/assets/user/userList.png';
import _imports_3 from '@/assets/user/logout.png';
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "right"
};
const _hoisted_3 = {
  class: "user_name"
};
import { ref, onMounted } from 'vue';
import router from '@/router';
import api from '@/server/request/api';
import { ElMessage } from "element-plus";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const handleLogout = () => {
      api.logout().then(resp => {
        console.log(resp);
        ElMessage.success('退出登录成功');
        router.push('/login');
      });
    };
    const userInfo = ref(JSON.parse(localStorage.getItem('userInfo') || '{}'));
    onMounted(() => {
      console.log(userInfo.value);
    });
    const handleUserList = () => {
      if (userInfo.value.username == 'admin') {
        router.push('/user');
      } else {
        router.push(`/user/edit/${userInfo.value.id}`);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title"
      }, "中科金联综合服务平台", -1)), _cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "tit_bj",
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_dropdown, null, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [userInfo.value.username == 'admin' ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            onClick: handleUserList
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
              src: _imports_2,
              class: "logout_img"
            }, null, -1), _createTextVNode(" 用户管理 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
            onClick: handleLogout
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
              src: _imports_3,
              class: "logout_img"
            }, null, -1), _createTextVNode(" 退出登录 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("img", {
          src: _imports_1,
          class: "logout_img",
          style: {
            "margin-right": "5px"
          }
        }, null, -1)), _createTextVNode(" " + _toDisplayString(userInfo.value.username), 1)])]),
        _: 1
      })])]);
    };
  }
});